import { defineSchema, SchemaInstance } from "../type-system/schema";

export const workOrderSchema = defineSchema({ fields: {} });

export const exampleWorkOrderSchemaInstance: SchemaInstance<
  typeof workOrderSchema
> = {};
